(ns common.schema.entities.insider-group
  (:require
   [common.schema.schema-utils :as su]
   [common.schema.option-filters :as option-filters]))

(def status-options
  [{:key     :insider-group.status/active
    :id      :insider-group.status/active
    :keyword :insider-group.status/active
    :label   "Active"}
   {:key     :insider-group.status/inactive
    :id      :insider-group.status/inactive
    :keyword :insider-group.status/inactive
    :label   "Inactive"}
   {:key     :insider-group.status/public
    :id      :insider-group.status/public
    :keyword :insider-group.status/public
    :label   "Made public"}])

(def schema
  (vec
   (concat
    (su/name-unique-per-tenant :insider-group/name "Name" :entity.type/insider-group {})
    (su/multi-ref-field :insider-group/members
                        "Authorized members"
                        [:entity.type/account]
                        {:option-filter-fn         option-filters/active-users
                         :default-field-visibility :in-use
                         :os-filter-terms-fn       (fn [{:keys [] :as args}]
                                                     {"extras.active-user" true})})
    (su/multi-ref-field :insider-group/teams "Authorized teams" [:entity.type/team] {:default-field-visibility :in-use})
    (su/keyword-field :insider-group/status
                      "Status"
                      status-options
                      {:field-in-use-filter
                       (fn [{:keys [entity]}]
                         (not (:db/id entity)))}))))
